export default {
  id: null,
  nome: null,
  situacao: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/reasonmodel.js